// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Legend_wrapper__1sAxN","item":"Legend_item__2lQGi","color":"Legend_color__jdGhw"};